import {Module} from 'module/Module'
import {fetchDqButtonsAction} from 'module/DqButton/action/DqButtonsAction'
import {DqButtonReducerNS} from 'module/DqButton/reducer/DqButtonReducer'
import {DqButtonEpic} from 'module/DqButton/epic/DqButtonEpic'
import {GenericDqButtonSinkEpic} from 'module/DqButton/epic/DqButtonSinkEpic'

export const DqButtonModule: Module = {
	actions: [fetchDqButtonsAction()],
	epics: [DqButtonEpic, GenericDqButtonSinkEpic], // implement CFDef-specific sinks!
	reducerNS: DqButtonReducerNS,
}